import {
  BrowserMessageReceiveType,
  registerElectronMessageReceiver,
} from 'electron-communication-lib/BrowserForApp';
import {useMountEffect} from 'webapp-lib/utils';

import {useRouteNavigate} from '_/hooks/useRouteNavigate';

export const useOpenFileCommand = (): void => {
  const {goToCasusDocuments} = useRouteNavigate();

  useMountEffect(() => {
    registerElectronMessageReceiver(
      BrowserMessageReceiveType.EXTERNAL_DOCUMENT_OPEN,
      (openDocumentUrlParams) =>
        goToCasusDocuments({
          casusId: openDocumentUrlParams.casusId,
          folderId: openDocumentUrlParams.folderId,
          documentId: openDocumentUrlParams.documentId,
          action: 'open-document',
        })
    );
  });
};
